fragment CraftLink on LinkData {
    value
    label
    elementTitle
    urlSuffix
}